import { render, staticRenderFns } from "./k-tree.vue?vue&type=template&id=4ba6c777&scoped=true"
import script from "./k-tree.vue?vue&type=script&lang=js"
export * from "./k-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6c777",
  null
  
)

export default component.exports